// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBoLzQSwcD7AKJLdddgE0L5IIAr767hj54",
  authDomain: "idmccrossworld2023.firebaseapp.com",
  projectId: "idmccrossworld2023",
  storageBucket: "idmccrossworld2023.appspot.com",
  messagingSenderId: "314816964651",
  appId: "1:314816964651:web:2c67cb3e2ff01dca3c226e",
  measurementId: "G-NV0KJHDY4L",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage };
